module.exports = {
          srcSet: __webpack_public_path__ + "images/1997-22e47b312bb01b8c30de922834939f0b-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1997-50f1edbdb045a02e9569cd4af17905cd-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1997-22e47b312bb01b8c30de922834939f0b-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1997-50f1edbdb045a02e9569cd4af17905cd-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1997-22e47b312bb01b8c30de922834939f0b-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1997-22e47b312bb01b8c30de922834939f0b-320.jpg"},
          
          width: 320,
          height: 251
        }